__turbopack_context__.v({
  "bottom": "Footer-module__S6Hkya__bottom",
  "bottomLink": "Footer-module__S6Hkya__bottomLink",
  "bottomLinks": "Footer-module__S6Hkya__bottomLinks",
  "bottomRight": "Footer-module__S6Hkya__bottomRight",
  "brandCol": "Footer-module__S6Hkya__brandCol",
  "brandDesc": "Footer-module__S6Hkya__brandDesc",
  "column": "Footer-module__S6Hkya__column",
  "contactInfo": "Footer-module__S6Hkya__contactInfo",
  "contactLabel": "Footer-module__S6Hkya__contactLabel",
  "contactValue": "Footer-module__S6Hkya__contactValue",
  "container": "Footer-module__S6Hkya__container",
  "copyright": "Footer-module__S6Hkya__copyright",
  "divider": "Footer-module__S6Hkya__divider",
  "footer": "Footer-module__S6Hkya__footer",
  "grid": "Footer-module__S6Hkya__grid",
  "heart": "Footer-module__S6Hkya__heart",
  "links": "Footer-module__S6Hkya__links",
  "phoneLink": "Footer-module__S6Hkya__phoneLink",
  "scrizaLink": "Footer-module__S6Hkya__scrizaLink",
  "socialCard": "Footer-module__S6Hkya__socialCard",
  "socials": "Footer-module__S6Hkya__socials",
  "title": "Footer-module__S6Hkya__title",
});
